import classNames from "classnames";
import Modal from "components/Modal";
import { FC } from "react";

import ModalRemoveContent from "./Content";

import styles from "./style.module.scss";

type PropTypes = {
  isVisible: boolean;
  className?: string;
  id?: number;
  companyId?: number;
  name?: string;
};

const WidgetModalRemoveUser: FC<PropTypes> = ({ isVisible, className, id, companyId, name }) => {
  return (
    <Modal title="Delete user" isClose isCloseBg isVisible={isVisible} className={classNames(styles.modal, className)}>
      <ModalRemoveContent id={id} name={name} companyId={companyId} />
    </Modal>
  );
};

export default WidgetModalRemoveUser;
